<template>
  <div class="c-featured-ring-size">
    <div
      v-if="!isMobile" 
      class="l-grid l-grid--2-col l-grid--mobile-tab-port"
    >
      <div
        v-if="image && image.src"
        class="c-featured-ring-size__image"
        :style="{
          background: `url(${image.src}) no-repeat center`,
        }"
      />
      <div
        :class="gridItemClass"
        class="u-left-text"
      >
        <div class="u-text-align-left">
          <h2
            v-if="title"
            class="
              c-featured-ring-size-title
              u-margin-bottom-x-small
            "
            :class="titleTypography"
          >
            {{ title }}
          </h2>
          <wysiwyg
            v-if="description"
            :html="description"
            paragraph-size="large"
            class="u-margin-bottom-medium"
          />
        </div>
        <btn
          v-if="cta"
          v-bind="cta"
        >
          {{ cta.text }}
        </btn>
      </div>
    </div>
    <div 
      v-else
      class="c-featured-ring-size-mobile"
    >
      <div class="u-center-text">
        <div class="u-text-align-center">
          <h2
            v-if="title"
            class="
              c-featured-ring-size-mobile-title
              u-margin-bottom-x-small
            "
            :class="titleTypography"
          >
            {{ title }}
          </h2>
          <div
            v-if="image && image.src"
            class="c-featured-ring-size__image-mobile"
            :style="{
              background: `url(${image.src}) no-repeat center`,
            }"
          />
          <wysiwyg
            v-if="description"
            :html="description"
            paragraph-size="large"
            class="c-featured-ring-size-mobile-description u-margin-bottom-medium"
          />
        </div>
        <btn 
          v-if="cta" 
          class="c-featured-ring-size-mobile-cta"
          type="primary-open"
          v-bind="cta"
        >
          {{ cta.text }}
        </btn>
      </div>
    </div>
  </div>
</template>
  
<script>
import Btn from "@/components/button/Btn";
import Wysiwyg from "../wysiwyg/Wysiwyg";
import isMobile from "@mixins/isMobile";

/**
 * wrap the stateless HomepageFeaturedRings component in a stateful context
 */
export default {
  components: {
    Btn,
    Wysiwyg,
  },
  mixins: [isMobile],
  props: {
    title: {
      type: String,
      default: "",
    },
    titleTypography: {
      type: String,
      default: "t-heading-3",
    },
    description: {
      type: String,
      default: "",
    },
    image: {
      type: Object,
      default: () => ({}),
    },
    video: {
      type: Object,
      default: () => ({}),
    },
    mediaSide: {
      type: String,
      default: "left",
    },
    cta: {
      type: Object,
      default: null,
    },
  },
  computed: {
    gridItemClass() {
      if (this.mediaSide == "right") {
        return "l-grid__item l-grid__item--first-until-tab-port";
      } else {
        return "l-grid__item";
      }
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.c-featured-ring-size {
  &-title {
    margin-top: 30px;
  }

  &__image {
    margin-top: 30px;
    width: 100%;
    height: 0;
    padding-top: 66.64%;
    background-size: contain !important;
    &-mobile {
      width: 100%;
      padding-top: 66.64%;
      background-size: 100% 100% !important;
      margin: 30px 0px;
    }
    &--right {
      order: 2;
    }
  }

  &-mobile {
    @include themify($themes) {
      border-color: themed("primary");
      background-color: themed("primary");
      color: themed("foreground", "white-text");
    }
    &-title {
      padding-top: 30px;
      max-width: 300px;
      margin: auto;
    }
    &-description {
      max-width: 350px;
      margin: auto;
    }
    &-cta {
      margin-bottom: 30px;
    }
  }
}
</style>
  